import type { SVGProps } from 'react';

const SvgClassM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <g clipPath='url(#clip0_669_26675)'>
      <path
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
        fill='#2B2D30'
      />
      <path
        d='M12 17.4001C11.3894 17.4001 10.8943 16.9012 10.8943 16.2859V10.2858C10.8943 9.48216 10.2454 8.82841 9.44791 8.82841C8.65037 8.82841 8.00154 9.48217 8.00154 10.2858V16.2859C8.00154 16.9012 7.50641 17.4001 6.89579 17.4001C6.28518 17.4001 5.79004 16.9012 5.79004 16.2859V10.2858C5.79004 8.25333 7.43081 6.6001 9.44792 6.6001C11.465 6.6001 13.1058 8.25333 13.1058 10.2858V16.2859C13.1058 16.9012 12.6106 17.4001 12 17.4001Z'
        fill='#01BFB1'
      />
      <path
        d='M17.1045 17.4001C16.4939 17.4001 15.9988 16.9012 15.9988 16.2859V10.2858C15.9988 9.48216 15.3499 8.82841 14.5524 8.82841C13.7549 8.82841 13.106 9.48217 13.106 10.2858V16.2859C13.106 16.9012 12.6109 17.4001 12.0003 17.4001C11.3897 17.4001 10.8945 16.9012 10.8945 16.2859V10.2858C10.8945 8.25333 12.5353 6.6001 14.5524 6.6001C16.5695 6.6001 18.2103 8.25333 18.2103 10.2858V16.2859C18.2103 16.9012 17.7151 17.4001 17.1045 17.4001Z'
        fill='#01BFB1'
      />
    </g>
    <defs>
      <clipPath id='clip0_669_26675'>
        <rect width={24} height={24} fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClassM;
